// @flow
import { authenticatedFetch } from '../../api/request';

export default async function fetchAuthenticatedUser() {
    return await authenticatedFetch('/v5/user');
}
